var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26659 9.66634L0.333252 8.73301L4.06659 4.99967L0.333252 1.26634L1.26659 0.333008L4.99992 4.06634L8.73325 0.333008L9.66658 1.26634L5.93325 4.99967L9.66658 8.73301L8.73325 9.66634L4.99992 5.93301L1.26659 9.66634Z",
    fill: "#873CAA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.0c07a3e9728dcc1ae28893e861349d09.svg";
export { ForwardRef as ReactComponent };